export default __webpack_public_path__ + "static/media/hotei21.46a113ce.webp";